import { createSlice } from "@reduxjs/toolkit"
import { RootState } from "./store/store"
import { thunkicatch, thunkify } from "./thunk/thunkify"
import {
    CheckProfessionalAuthSpecification,
    SignInProfessionalSpecification
} from "pokal_api"
import { removeJwt, setJwt } from "../storage/jwt"

export interface ProfessionalAuthenticationState {
    authenticated: boolean
    user: {
        firstName: string
        lastName: string
        email: string
        otp: string
        officeName: string
    } | null
    token: string | null
}

const name = "professionalAuthenticationSlice"
const initialState: ProfessionalAuthenticationState = {
    authenticated: false,
    user: null,
    token: null
}
const professionalAuthenticationSlice = createSlice({
    name,
    initialState,
    reducers: {
        logoutProfessional: (state) => {
            state.authenticated = false
            state.user = null
            state.token = null
            removeJwt()
        }
    },
    extraReducers: (builder) => {
        thunkify(builder, SignInProfessionalSpecification, (state, action) => {
            setJwt(action.payload.token)
            state.authenticated = true
            state.user = { ...action.payload }
            state.token = action.payload.token
        })
        thunkify(
            builder,
            CheckProfessionalAuthSpecification,
            (state, action) => {
                setJwt(action.payload.token)
                state.authenticated = true
                state.user = { ...action.payload }
                state.token = action.payload.token
            }
        )
        thunkicatch(builder, CheckProfessionalAuthSpecification, (state) => {
            state.authenticated = false
            state.user = null
            state.token = null
            removeJwt()
        })
    }
})

export const selectProfessionalAuthenticationState = (state: RootState) =>
    state.professionalAuthentication.authenticated

export const selectProfessionalUser = (state: RootState) =>
    state.professionalAuthentication.user
export const selectProfessionalUserToken = (state: RootState) =>
    state.professionalAuthentication.token

export const { logoutProfessional } = professionalAuthenticationSlice.actions

export default professionalAuthenticationSlice.reducer
